import styled, { css } from "styled-components";

import DefaultRow from "components/Form/Row";

export const Container = styled.div``;

export const Column = styled.div`
  display: flex;
  flex-direction: column;

  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "100%"};
    `}

  &:not(:last-child) {
    margin-right: 32px;
  }
`;

export const Row = styled(DefaultRow)`
  margin-bottom: 0;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const Wrapper = styled.div``;

export const TitleRow = styled(DefaultRow)`
  margin-bottom: 10px;
`;
